import { css } from "@emotion/react";
import clone from "clone";
import { ImageIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useCheckoutFormState } from "../../../hooks/useCheckoutFormState";
import type { Product } from "../../../hooks/useInventoryState";
import { useProductDetailsState } from "../../../hooks/useProductDetailsState";
import type { ShoppingCartItemModel } from "../../../hooks/useShoppingCartItemsState";

export type ShoppingCartItemImageProps = {
	item: ShoppingCartItemModel;
};
export const ShoppingCartItemImage: React.FC<ShoppingCartItemImageProps> = (
	props,
) => {
	const item = props.item;
	const productDetailsState = useProductDetailsState();
	const imageSize = 64;
	const checkoutFormState = useCheckoutFormState();
	const warehouseId = checkoutFormState.get().warehouseIdValue;
	const locationId = checkoutFormState.get().locationIdValue;
	const fromDate = checkoutFormState.get().fromDateValue;
	const toDate = checkoutFormState.get().toDateValue;
	const navigate = useNavigate();

	return (
		<>
			{(!productDetailsState.get().showPopup ||
				item.product.Id !== (productDetailsState.get().product?.Id ?? "")) && (
				<div
					className="image"
					css={css`
                        flex: 0;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        @media (min-width: 450px) {
                            flex: 0 0 ${imageSize}px;
                        }`}
				>
					{(!item.product.Images || !item.product.Images.length) && (
						<button
							type="button"
							aria-label={item.product.ItemName}
							key={0}
							css={css`
                                display:inline-block;
                                width:${imageSize}px;
                                height:${imageSize}px;
                                display:flex;
                                align-items:center;
                                justify-content:center;
								border: 0;
								padding: 0;
								background: transparent;
                                cursor: pointer;`}
							onClick={async () => {
								return Promise.resolve().then(async () => {
									await productDetailsState.setProductAsync(
										clone(item.product) as Product,
									);
									navigate(
										`/product/${item.product.Id}/warehouseid/${warehouseId}/locationid/${locationId}/fromdate/${fromDate}/todate/${toDate}`,
									);
									//productDetailsState.setShowPopup(true);
								});
							}}
						>
							<ImageIcon css={css`width:100%;height:100%;color:#777777;`} />
						</button>
					)}
					{item.product.Images?.length && (
						<button
							type="button"
							aria-label={item.product.ItemName}
							css={css`
                                display:inline-block;
                                width:${imageSize}px;
                                height:${imageSize}px;
                                background-image:url(${item.product.Images[0].Url});
                                background-position:center;
                                background-repeat:no-repeat;
                                background-size:contain;
								border: 0;
								padding: 0;
								background-color: transparent;
                                cursor: pointer;`}
							onClick={async () => {
								return Promise.resolve().then(async () => {
									await productDetailsState.setProductAsync(
										clone(item.product) as Product,
									);
									navigate(
										`/product/${item.product.Id}/warehouseid/${warehouseId}/locationid/${locationId}/fromdate/${fromDate}/todate/${toDate}`,
									);
									//productDetailsState.setShowPopup(true);
								});
							}}
						></button>
					)}
				</div>
			)}
		</>
	);
};
